var React = require('react');

function Error (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Error Graphic"),React.createElement("path",{"d":"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z","fill":"#DA291C","key":1}),React.createElement("path",{"d":"M11 11.25C11 11.6642 10.664 12 10.25 12H9.75C9.336 12 9 11.6642 9 11.25V5.5C9 5.08575 9.336 4.75 9.75 4.75H10.25C10.664 4.75 11 5.08575 11 5.5V11.25Z","fill":"white","key":2}),React.createElement("path",{"d":"M11 14.5C11 14.9143 10.664 15.25 10.25 15.25H9.75C9.336 15.25 9 14.9143 9 14.5V14C9 13.5858 9.336 13.25 9.75 13.25H10.25C10.664 13.25 11 13.5858 11 14V14.5Z","fill":"white","key":3})]);
}

Error.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Error;

Error.default = Error;
